import { useState } from 'react';
import PropTypes from 'prop-types';

import { trans, useSoyuzLocales, useSoyuzFlag } from '@spotahome/soyuz/client';

import LazyLoginSignUpModal from '@spotahome/ui-library/src/tenant/components/LoginSignupModal';

import {
  traditionalSignup,
  traditionalLogin,
  traditionalForgotPassword
  // eslint-disable-next-line import/no-unresolved
} from '../../common/api/traditional-login-client';

const reloadPage = () => document.location.reload();

const LoginModal = ({
  onTraditionalLoginSuccess = reloadPage,
  onTraditionalSignupSuccess = reloadPage
}) => {
  const { current: locale } = useSoyuzLocales();
  const [error, setError] = useState(null);
  const hideTraditionalAuth = useSoyuzFlag('HideTraditionalAuth').isOn();
  const hideFacebookOauth = useSoyuzFlag('HideFacebookOauth').isOn();
  const hideGoogleOauth = useSoyuzFlag('HideGoogleOauth').isOn();

  const handleTraditionalLogin = async ({ email, password }) => {
    try {
      setError(null);
      await traditionalLogin({ email, password });
      onTraditionalLoginSuccess();
    } catch (e) {
      setError(trans('login.error'));
      console.error(e);
    }
  };

  const handleTraditionalSignup = async ({
    name,
    email,
    password,
    marketingOptIn
  }) => {
    try {
      setError(null);
      await traditionalSignup({
        name,
        email,
        password,
        marketingOptIn,
        locale
      });
      onTraditionalSignupSuccess();
    } catch (e) {
      setError(trans('signup.error'));
      console.error(e);
    }
  };
  const handleForgottenPassword = async ({ email }) => {
    try {
      setError(null);
      await traditionalForgotPassword({ email });
    } catch (err) {
      setError(trans('forgotten-password.error'));
      console.error(err);
    }
  };

  return (
    <LazyLoginSignUpModal
      locale={locale}
      onTraditionalLogin={handleTraditionalLogin}
      onTraditionalSignup={handleTraditionalSignup}
      onForgottenPassword={handleForgottenPassword}
      error={error}
      hideTraditionalAuth={hideTraditionalAuth}
      hideFacebookOauth={hideFacebookOauth}
      hideGoogleOauth={hideGoogleOauth}
    />
  );
};

LoginModal.propTypes = {
  onTraditionalLoginSuccess: PropTypes.func,
  onTraditionalSignupSuccess: PropTypes.func
};

export default LoginModal;
